// De knop voor in je bladwijzerbalk: één klik en de pagina die je leest staat in je Inbox.
//
// Waarom een bookmarklet en niet een browser-uitbreiding: een uitbreiding moet je per browser
// bouwen, ondertekenen en bijhouden, en hij vraagt om toegang tot álles wat je leest. Dit is
// één regel javascript in een bladwijzer, werkt in elke browser, en je kunt hem lezen.
//
// Waarom hij een venstertje opent in plaats van de pagina rechtstreeks naar de NAS te sturen:
// dat laatste wás de eerste versie, en die liep stuk op Wikipedia. Sites zetten tegenwoordig
// een Content-Security-Policy, en een bookmarklet valt daar in Chrome gewoon onder:
//
//     Connecting to 'https://note.vuzenet.nl/api/ext/clip' violates the following
//     Content Security Policy directive: "default-src 'self' …". The action has been blocked.
//
// `postMessage` valt níet onder die regels, en `window.open` ook niet. Dus opent de knop een
// klein venster op onze eigen site, en schuift de pagina daar naartoe. Twee dingen worden er
// beter van: het werkt ook op sites die alles dichttimmeren, en er hoeft geen token in je
// bladwijzer te staan — het venster is de app zelf, met je gewone aanmelding.
//
// Dat het de html meestuurt die jij vóór je hebt, is meteen het verschil met het pad via de
// telefoon, waar de NAS de pagina zelf ophaalt: wat achter een aanmelding of een leeslimiet
// staat, ziet de NAS niet en jouw browser wél.

/** Het venster meldt zich met dit bericht zodra het klaarstaat; dan pas sturen we de pagina. */
export const KLAAR = "notities-clip-klaar";

/** En zo heet het bericht met de pagina zelf. */
export const LADING = "notities-clip";

/** Zoveel html sturen we mee; daarboven laten we de NAS de pagina zelf ophalen. */
const GROOTSTE_PAGINA = 4_000_000;

/**
 * De javascript:-url die in de bladwijzer komt.
 *
 * `basis` is de plek waar de app draait (`https://note.vuzenet.nl`); die zetten we erin omdat
 * de bookmarklet op een héél andere site draait en dus niets van ons weet.
 */
export function maakBookmarklet(basis: string): string {
  const code = `void (() => {
  const basis = ${JSON.stringify(basis)};
  const venster = open(basis + "/clip", "notities-clip", "width=560,height=680");
  if (!venster) {
    alert("Notities kon geen venster openen. Sta pop-ups toe voor deze site en klik nog een keer.");
    return;
  }
  const html = document.documentElement.outerHTML;
  const lading = {
    soort: ${JSON.stringify(LADING)},
    url: location.href,
    titel: document.title,
    html: html.length > ${GROOTSTE_PAGINA} ? "" : html
  };
  const luister = (bericht) => {
    if (bericht.origin !== basis) return;
    if (!bericht.data || bericht.data.soort !== ${JSON.stringify(KLAAR)}) return;
    venster.postMessage(lading, basis);
    removeEventListener("message", luister);
  };
  addEventListener("message", luister);
  // Blijft het venster stil (geen verbinding, of je moet eerst aanmelden en dat duurt), dan
  // ruimen we onszelf op in plaats van eindeloos te blijven luisteren.
  setTimeout(() => removeEventListener("message", luister), 300000);
})();`;

  // Percent-coderen, want een bladwijzer is een url: een spatie of een # erin breekt hem af.
  // De browser draait hem na het decoderen, dus de code blijft leesbaar als je hem uitpakt.
  return "javascript:" + encodeURIComponent(code);
}
